import { Link } from "react-router-dom";
import Logo from "./Logo";

const LINKS = [
    { label: "ACASĂ", to: "/" },
    { label: "CAROTARE", to: "/carotare" },
    { label: "DEMOLĂRI / TĂIERI", to: "/demolari-taiere" },
    { label: "ȘLEFUIRE", to: "/slefuire" },
    { label: "REPASTILARE CAROTE", to: "/repastilare-carote" },
    { label: "CONTACT", to: "/contact" },
];

export default function Footer() {
    return (
        <footer
            data-testid="footer-section"
            className="border-t border-line bg-ink py-10 lg:py-12"
        >
            <div className="mx-auto flex max-w-[1600px] flex-col gap-8 px-5 lg:flex-row lg:items-center lg:justify-between lg:px-10">
                <Link to="/" data-testid="footer-logo-link">
                    <Logo />
                </Link>

                <nav className="flex flex-wrap gap-x-6 gap-y-3">
                    {LINKS.map((l) => (
                        <Link
                            key={l.to}
                            to={l.to}
                            data-testid={`footer-link-${l.to === "/" ? "acasa" : l.to.slice(1)}`}
                            className="font-mono-tech text-[10px] tracking-[0.2em] text-mist transition-colors duration-300 hover:text-flame"
                        >
                            {l.label}
                        </Link>
                    ))}
                </nav>

                <p className="font-mono-tech text-[10px] tracking-[0.2em] text-mist/70">
                    © 2026 CAROTE.RO — TOATE DREPTURILE REZERVATE
                </p>
            </div>
        </footer>
    );
}